/**
 * Configuração de Axios com suporte a Tenant
 * 
 * DEPRECATED: Este arquivo foi refatorado para seguir SOLID
 * Ver apps/frontend/src/services/ para implementação detalhada
 * 
 * Mantido por compatibilidade - delega para novos módulos
 */
import { setupHttpInterceptors } from '@/services/http-interceptor';
import { setupAppErrorMiddleware } from '@/services/app-error-middleware';

export function setupAxiosTenantHeader(): void {
  // Setup HTTP interceptors (request/response)
  setupHttpInterceptors();

  // Setup error display middleware
  setupAppErrorMiddleware();
}
